import { render, staticRenderFns } from "./CityEditView.vue?vue&type=template&id=51687b14&scoped=true"
import script from "./CityEditView.vue?vue&type=script&lang=js"
export * from "./CityEditView.vue?vue&type=script&lang=js"
import style0 from "./CityEditView.vue?vue&type=style&index=0&id=51687b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51687b14",
  null
  
)

export default component.exports